import { ICON_HEIGHT_8, IconNG } from '../../../Icon'
import { TableCellBase, TableTextCell, TableUserCell } from '../../../Table'
import { toUserMultiValue } from '../../../User'
import { TaskTableCellName, TaskTableItemCommitType } from '../../Task.enums'
import { isTaskDone } from '../../Task.utils'
import { TaskTableRowDeadline } from '../../TaskTableRowDeadline'
import { TaskTableRowDoneStatus } from '../../TaskTableRowDoneStatus'
import { TaskTableRowPriority } from '../../TaskTableRowPriority'
import { TaskTableRowTitle } from '../../TaskTableRowTitle'
import { TaskTableRowYesNoStatus } from '../../TaskTableRowYesNoStatus'

import InvisibleIcon from '../../../../icons/dot.svg'
import VisibleIcon from '../../../../icons/eye-filled.svg'

export function renderCell({ item, name, ...restProps }) {
  const { commit_type: commitType, [name]: value } = item

  const done = isTaskDone(item)

  switch (name) {
    case TaskTableCellName.Status:
      switch (commitType) {
        case TaskTableItemCommitType.YesNo:
          return <TaskTableRowYesNoStatus {...restProps} disabled item={item} />
        case TaskTableItemCommitType.Done:
        default:
          return <TaskTableRowDoneStatus {...restProps} disabled item={item} />
      }

    case TaskTableCellName.Title:
      return <TaskTableRowTitle {...restProps} item={item} />

    case TaskTableCellName.ActivityType:
    case TaskTableCellName.Phase:
      return <TableTextCell {...restProps} done={done} value={value?.name} />

    case TaskTableCellName.VisibleToTenant:
      return (
        <TableCellBase {...restProps}>
          <IconNG
            {...(item.visible_to_tenant ? null : { size: ICON_HEIGHT_8 })}
            Icon={item.visible_to_tenant ? VisibleIcon : InvisibleIcon}
          />
        </TableCellBase>
      )

    case TaskTableCellName.Manager:
      return (
        <TableUserCell
          {...restProps}
          done={done}
          value={value ? toUserMultiValue(value) : null}
        />
      )

    case TaskTableCellName.Deadline:
      return <TaskTableRowDeadline {...restProps} item={item} />

    case TaskTableCellName.Priority:
      return <TaskTableRowPriority {...restProps} item={item} />

    default:
      return null
  }
}
